import { useMutation } from "@tanstack/react-query";

import { STEP_API_ENDPOINT } from "../../../utils/swr";
import { downloadFile } from "../../../utils/utils";
import type { TransactionsFilters } from "../../stores/transactionHistoryStore";

export interface DownloadHistoryMutationParams {
  filters: TransactionsFilters;
  year?: number | string;
}

export const useDownloadHistory = (wallet?: string) => {
  return useMutation({
    mutationFn: (data: DownloadHistoryMutationParams) => downloadHistoryCSV(data.filters, data.year, wallet),
  });
};

const downloadHistoryCSV = async (filters: TransactionsFilters, year?: number | string, wallet?: string) => {
  const filtersBody: { filters: Partial<TransactionsFilters> } = {
    filters: {
      ...filters,
      page: 1,
      itemsPerPage: 1000000,
    },
  };
  try {
    const jwt = JSON.parse(localStorage.getItem("jwt") || "");
    const data = await fetch(`${STEP_API_ENDPOINT}/v1/transaction-history/csv?pubkey=${wallet}&year=${year}`, {
      method: "POST",
      body: JSON.stringify(filtersBody),
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${jwt}`,
      },
    });
    const blob = await data.blob();
    downloadFile({
      data: blob,
      fileName: `transaction-history-${year}-${wallet?.slice(0, 6)}`,
      fileType: "text/csv;charset=utf-8;",
    });
  } catch (error) {
    console.error("Error Downloading Tx History CSV:", error);
  }
  return {};
};
